import React, { useState } from "react";
import AuthForm from "../AuthForm/AuthForm";
import { validateEmail } from "../../../util/email";
import "./AuthContent.css";

function AuthContent({ onAuthenticate }) {
  const [credentialsInvalid, setCredentialsInvalid] = useState({
    email: false,
    password: false,
    confirmPassword: false,
  });

  function submitHandler(credentials) {
    let { email, password } = credentials;
    const emailIsValid = validateEmail(email);
    password = password.trim();
    const passwordIsValid = password.length >= 5;

    if (!emailIsValid || !passwordIsValid) {
      alert("Datos inválidos", "Revisa los datos que ingresaste.");
      setCredentialsInvalid({
        email: !emailIsValid,
        password: !passwordIsValid,
      });
      return;
    }
    onAuthenticate({ email, password });
  }

  return (
    <div className="mainContainer">
      <div className="authContentContainer">
        <AuthForm
          onSubmit={submitHandler}
          credentialsInvalid={credentialsInvalid}
        />
      </div>
    </div>
  );
}

export default AuthContent;
